import React, { useState, useEffect, useRef } from 'react';
import AppointmentCard from '../components/AppointmentCard';
import '../assets/css/appointmentCard.css';
import { Quantum } from 'ldrs/react';
import 'ldrs/react/Quantum.css';
import { useNavigate } from 'react-router-dom';
import DashboardFooter from '../components/DashboardFooter';

const Appointment = () => {
  const [appointments, setAppointments] = useState([]);
  const [appointmentsDates, setAppointmentsDates] = useState([]);
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(1);
  const [searchTerm, setSearchTerm] = useState('');
  const [highlightDate, setHighlightDate] = useState(() => {
    const today = new Date();
    const yyyy = today.getFullYear();
    const mm = String(today.getMonth() + 1).padStart(2, '0'); // Months are 0-based
    const dd = String(today.getDate()).padStart(2, '0');
    return `${yyyy}-${mm}-${dd}`;
  });
  const [selectedDate, setSelectedDate] = useState(() => {
    const today = new Date();
    const yyyy = today.getFullYear();
    const mm = String(today.getMonth() + 1).padStart(2, '0');
    const dd = String(today.getDate()).padStart(2, '0');
    return `${yyyy}-${mm}-${dd}`;
  });
  const debounceTimeoutRef = useRef(null);
  const navigate = useNavigate();



  // Separate function to fetch appointments
  const fetchAppointments = async (dateToFetch = selectedDate) => {
    try {
      setLoading(true);
      const token = localStorage.getItem("token");
      if (!token) {
        console.log("No token found");
        setLoading(false);
        return;
      }

      const url = `${process.env.REACT_APP_HOST_API_URL}/admin-user/all-appointments/?page=${page}`;
      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ date: `${dateToFetch}T00:00:00` }),
      });

      if (!response.ok) throw new Error(`Data not found ${response.status}`);

      const data = await response.json();
      console.log("data", data)
      setAppointments(data.results || []);
      setAppointmentsDates(
        data.available_dates
      );
    } catch (error) {
      console.error("Error fetching appointments:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchAppointments();
  }, [page]);


  // Filter appointments based on search term (mobile number and assigned_to)
  const filteredAppointments = appointments.filter(appointment => {
    if (!searchTerm) return true;

    // Search in mobile number
    const mobileMatch = appointment.mobile && appointment.mobile.toString().toLowerCase().includes(searchTerm.toLowerCase());

    // Search in assigned_to field
    const assignedMatch = appointment.assigned_to && appointment.assigned_to.length > 0 &&
      appointment.assigned_to.some(assignee => {
        const username = assignee.full_name || '';
        const name = assignee.name || '';
        const email = assignee.email || '';
        return username.toLowerCase().includes(searchTerm.toLowerCase()) ||
          name.toLowerCase().includes(searchTerm.toLowerCase()) ||
          email.toLowerCase().includes(searchTerm.toLowerCase());
      });

    return mobileMatch || assignedMatch;
  });

  // Handle search form submission
  const handleSearch = (e) => {
    e.preventDefault();
    // Search is handled by the filteredAppointments filter above
  };

  // Handle date change - only update state, don't call API immediately
  const handleDateChange = (e) => {
    const newDate = e.target.value;
    setSelectedDate(newDate);
    setHighlightDate(newDate);
  };

  // Handle date selection - call API only when user actually selects a date
  const handleDateSelect = () => {
    if (selectedDate) {
      console.log('Fetching appointments for selected date:', selectedDate);
      fetchAppointments(selectedDate);
    }
  };

  // Handle today button click
  const handleTodayClick = () => {
    const today = new Date();
    const yyyy = today.getFullYear();
    const mm = String(today.getMonth() + 1).padStart(2, '0');
    const dd = String(today.getDate()).padStart(2, '0');
    const todayString = `${yyyy}-${mm}-${dd}`;

    setSelectedDate(todayString);
    setHighlightDate(todayString);
    fetchAppointments(todayString);
  };

  // Format date for display
  const formatDateForDisplay = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    });
  };


  const handleEdit = (appointment) => {
    const formatDate = (dateTime) => dateTime ? dateTime.split("T")[0] : "";
    const formatTime = (dateTime) => dateTime ? dateTime.split("T")[1]?.slice(0, 5) : "";

    console.log("Raw appointment from backend:", appointment);
    console.log("assigned_to:", appointment.assigned_to);

    const fullAppointment = {
      id: appointment.id,
      title: appointment.title || "",
      name: appointment.name || "",
      number: appointment.mobile || "",
      address: appointment.address || "",
      description: appointment.description || "",
      customerId: appointment.customer?.id || "",

      startFrom: formatDate(appointment.start_from),
      endAt: formatDate(appointment.end_at),
      startTime: formatTime(appointment.start_from),
      endTime: formatTime(appointment.end_at),


      assignTo: (appointment.assigned_to || []).map(emp => emp?.username || ""),

      location: {
        latitude: appointment.lat || "",
        longitude: appointment.lon || "",
      },
      isMultiple: appointment.isMultiple || false,
    };

    console.log("full appointment mapped:", fullAppointment);

    navigate(`/dashboard/add-appointment/${appointment.id}`, {
      state: { appointment: fullAppointment },
    });
  };



  if (loading) return (
    <>
      <div className="d-flex justify-content-center align-items-center " style={{
        minHeight: 'calc(100vh - 40px)',
        width: '100vw',
        marginLeft: '-280px',
        padding: '20px'
      }}>
        <Quantum
          size="45"
          speed="1.75"
          color="blue"
        />
      </div>
    </>
  );


  // Get unique dates from 'created_at'
  // const dates = appointmentsDates;

  const dates = [...(appointmentsDates || [])].sort(
    (a, b) => new Date(a) - new Date(b)
  );

  console.log('dates::', dates)
  console.log('datappointmentses::', appointments)

  return (
    <>
      <div className="d-flex flex-column min-vh-100 pb-2 px-3">
        {/* Main content area (scrolls normally) */}
        <div className="flex-grow-1">
          <div className='container-fluid px-2 px-md-4 ' style={{ paddingTop: '20px' }}>
            {/* Page Heading */}
            <div
              className="appointment-header row mb-4 bg-white shadow-sm border-bottom sticky-top py-3 px-md-3 px-2 rounded"
              style={{
                // zIndex: 1050,
                background: "linear-gradient(135deg, #0564bf, #89CFF0"
              }}>


              <div className="d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center "
                style={{ gap: '1rem' }}>
                <div className="">
                  <h3 className="text-light mb-1">
                    Appointments
                  </h3>
                  <p className="text-light mb-0">
                    View and manage all scheduled appointments
                  </p>
                </div>
                {/* Results Heading */}

                <div className="text-md-end">
                  <h5 className="text-light mb-1">
                    Results for {formatDateForDisplay(selectedDate)}
                  </h5>
                  <p className="text-light mb-0">
                    {filteredAppointments.length} appointment{filteredAppointments.length !== 1 ? 's' : ''} found
                  </p>
                </div>

              </div>

              <div className="d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center mt-3  "
                style={{ gap: '1rem' }} >
                <div className="d-flex flex-wrap align-items-center" style={{ gap: '0.5rem' }}>
                  <input
                    id="datePicker"
                    type="date"
                    className="form-control date-picker-custom form-control-sm "
                    value={selectedDate}
                    onChange={handleDateChange}
                    onBlur={handleDateSelect}
                  />
                  <button
                    type="button"
                    className="btn btn-outline-light btn-sm "
                    onClick={handleTodayClick}
                  // style={{
                  //   padding: '8px 16px',
                  //   fontSize: '13px',
                  //   fontWeight: '500'
                  // }}

                  >
                    <i className="fas fa-calendar-day me-1"></i>
                    Today
                  </button>
                  <button
                    type="button"
                    className="btn btn-outline-light btn-sm"
                    onClick={handleDateSelect}
                  // style={{
                  //   padding: '8px 16px',
                  //   fontSize: '13px',
                  //   fontWeight: '500'
                  // }}
                  >
                    Fetch
                  </button>
                </div>
                <form className="d-flex" role="search" onSubmit={handleSearch}>
                  <input
                    className="form-control form-control-sm "
                    type="search"
                    placeholder="Search by mobile or assigned person"
                    aria-label="Search"
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    style={{ minWidth: '260px' }}
                  />
                  {/* <button className="btn btn-outline-primary" type="submit">Search</button> */}
                </form>
              </div>
            </div>


            <div className="appointment-container px-3 mt-4">
              <div className="table-responsive">
                <table className="table align-middle">
                  <thead className='table-light'>
                    <tr>
                      {dates.map(date => (
                        <th scope="col" className={`text-center text-muted pt-2 ${highlightDate === date ? 'bg-body-secondary' : ''}`} key={date}>
                          <span
                            className={`text-center p-1 px-3 rounded  text-muted ${highlightDate === date ? 'bg-warning text-light' : ''}`}
                          >{date}</span>
                        </th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      {dates.map(date => (
                        <td style={{ minWidth: '12rem', verticalAlign: 'top' }} className={highlightDate === date ? 'bg-body-secondary' : ''} key={date}>
                          {filteredAppointments
                            .filter(a => a.start_from.startsWith(date))
                            .map(a => (
                              <AppointmentCard key={a.id} appointment={a} handleEdit={handleEdit} />
                            ))}
                        </td>
                      ))}
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
        <DashboardFooter />
      </div>

    </>
  );
};

export default Appointment;
